import React from "react";
import {TaxSettlement} from "models/Tax";
import {useOfficeTranslation} from "i18n/OfficeTranslation";

const TaxSettlementSummary: React.FC<{settlement: TaxSettlement}> = ({settlement}) => {
    const {t, intlLocale} = useOfficeTranslation();
    const format = (amount: number) => amount.toLocaleString(intlLocale, {style:"currency", currency:"EUR"});
    return <div className="tax-settlement-summary">
        <p className="small mb-2">{t("taxModule.settlementPaymentCount", {count:settlement.payment_count})}</p>
        <dl>
            <div><dt>{t("taxModule.settlementGross")}</dt><dd>{format(settlement.gross)}</dd></div>
            <div><dt>{t("taxModule.settlementNet")}</dt><dd>{format(settlement.net)}</dd></div>
            <div><dt>{t("taxModule.settlementFees")}</dt><dd>{format(settlement.fees)}</dd></div>
            <div><dt>{t("taxModule.settlementDifference")}</dt><dd>{format(settlement.difference)}</dd></div>
        </dl>
    </div>;
};
export default TaxSettlementSummary;
